import { DeviceDetailsComponent } from './../details/device-details.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../shared/translate/translate.module';


@NgModule({
  declarations: [DeviceDetailsComponent],
  imports: [
    CommonModule,
    IonicModule, TranslateModule
  ],
  exports: [
    DeviceDetailsComponent
  ]
})
export class DeviceDetailsModule { }
